import React from "react";
import HeroBenefitList from "../shared/HeroBenefitList.jsx";
import QuietVideoPlayer from "../shared/QuietVideoPlayer.jsx";

const QuietHero = ({ onOpenModal }) => (
  <section className="cursor-section" data-testid="quiet-hero">
    <div className="cursor-container">
      <div className="cursor-hero-message" data-testid="quiet-headline">
        <h1 className="cursor-hero-h1">
          Watch this 60-second video to see how FractoLabs:
        </h1>
        <HeroBenefitList />
      </div>

      <QuietVideoPlayer />

      <div className="cursor-hero-cta-block">
        <div className="cursor-hero-cta-shell">
          <button
            type="button"
            className="quiet-cta quiet-cta-primary"
            onClick={onOpenModal}
            data-testid="quiet-hero-cta"
          >
            <span>Plug FractoLabs in (Free)</span>
            <span className="quiet-cta-arrow" aria-hidden="true">
              →
            </span>
          </button>
          <p className="cursor-cta-caption">
            No credit card · Live in 8 minutes
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default QuietHero;
